import { useQuery } from "@tanstack/react-query";
import { getMagnetActivity } from "apis/magnets";
import UserAndMagnetActivityCard from "components/atoms/cards/user/UserAndMagnetActivityCard";
import { LoadingIcon } from "components/atoms/Icon";
import { get } from "utils/request";
import { useMemo } from "react";
import { ActivityEmptyStates } from "./EmptyStates";

type Props = {
  magnetId: string;
};

function MagnetActivity({ magnetId }: Props) {
  const { data: magnetActivity, isLoading } = useQuery<MagnetAndUserActivity[] | null>({
    queryKey: ["magnetActivity", magnetId],
    queryFn: () =>
      get(getMagnetActivity(magnetId), {
        processError: (errorMessage) => {
          throw new Error(errorMessage);
        },
      }),
  });

  const activities = useMemo(() => {
    if (isLoading)
      return (
        <div className="flex h-full w-full items-center justify-center">
          <div className="h-32 w-32">
            <LoadingIcon color="#102D4E" />
          </div>
        </div>
      );

    if (magnetActivity?.length) {
      return magnetActivity?.map((activity) => (
        <UserAndMagnetActivityCard
          key={`magnetActivity${activity.id}`}
          // @ts-ignore
          imageUrl={activity.image_url}
          title={activity.title}
          createdAt={activity.created_at}
          navigationLink={activity.cta}
          actionType={activity.action_type}
          subType={activity.sub_type}
          iconUrl={activity.icon_url}
          additionalClasses="!border-white !rounded-none !border-opacity-30"
        />
      ));
    }
    return <ActivityEmptyStates />;
  }, [isLoading, magnetActivity]);

  return (
    <div className="brand-activity-section aspect-h-11 aspect-w-11">
      <div className="flex  w-full flex-col rounded-2xl border-secondary md:border md:p-4">
        <p className="m-1 font-sora text-sm font-semibold text-white xl:text-xs 2xl:m-3 2xl:text-lg">Magnet Activity</p>
        <div
          className="mb-5 mt-2 flex-1
      space-y-2 divide-y divide-white divide-opacity-5 overflow-y-scroll scrollbar-hide"
        >
          {activities}
        </div>
      </div>
    </div>
  );
}

export default MagnetActivity;
